import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=f88ce268&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ce268",
  null
  
)

export default component.exports